<template>
	<div class="search-bar layout-row">
		<el-input :placeholder="placeholder" v-model="text" class="input" @keyup.enter.native="search" clearable @clear="search">
			<el-button slot="append" icon="el-icon-search" @click="search"></el-button>
		</el-input>
	</div>
</template>

<script>
export default {
	props: {
		searchText: {
			type: String,
			default: ""
		},
		placeholder: {
			type: String,
			default: "請輸入關鍵字"
		}
	},
	data() {
		return {
			text: ""
		};
	},
	computed: {},
	methods: {
		search() {
			this.$emit("search", this.text);
		},
		init() {
			this.text = this.searchText;
		}
	},
	created() {
		this.init();
	},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.search-bar {
	justify-content: flex-end;
}

.el-input {
	width: 350px;
}
</style>